import React from 'react'

const FieldArtifactsTab = () => {
        return (
            <div>
                Field Artifacts
            </div>
        )
}
export default FieldArtifactsTab
